import { isServer } from '@vue-storefront/core/helpers'

/** Production default when `storeView.url` is unset or a path prefix (e.g. `/de`). */
const FALLBACK_ORIGIN = 'https://www.zaun24.de'

/**
 * Public origin for SEO canonicals. `storeView.url` may be a bare host (`zaun24.de`),
 * full base URL, or a path prefix — the old `https://www.` + url + path concat produced
 * invalid URLs and broke vue-meta (`TypeError: Invalid URL`).
 */
function seoOrigin (storeView) {
  const raw = storeView && storeView.url != null ? String(storeView.url).trim() : ''
  if (!raw || raw.startsWith('/')) {
    return FALLBACK_ORIGIN
  }
  if (/^https?:\/\//i.test(raw)) {
    try {
      return new URL(raw).origin
    } catch {
      return FALLBACK_ORIGIN
    }
  }
  const host = raw.replace(/\/+$/, '').replace(/^\/+/, '')
  const fullHost = host.toLowerCase().startsWith('www.') ? host : `www.${host}`
  try {
    return new URL(`https://${fullHost}/`).origin
  } catch {
    return FALLBACK_ORIGIN
  }
}

/**
 * Absolute canonical href for `route`, or empty string if resolution fails (caller may omit link).
 */
export function storeCanonicalHref (storeView, route) {
  const path = route && route.path ? route.path : '/'
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  if (!isServer && typeof window !== 'undefined' && window.location && window.location.origin) {
    try {
      return new URL(normalizedPath, window.location.origin).href
    } catch {
      /* fall through to SSR-style origin */
    }
  }

  const base = seoOrigin(storeView)
  try {
    return new URL(normalizedPath, `${base}/`).href
  } catch {
    return ''
  }
}
